var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"playing",on:{"click":_vm.click}},[(_vm.step==1)?_c('font',{staticClass:"iconfont"},[_vm._v("")]):_vm._e(),_vm._v(" "),(_vm.step==2)?_c('font',{staticClass:"iconfont"},[_vm._v("")]):_vm._e(),_vm._v(" "),(_vm.step==3)?_c('font',{staticClass:"iconfont"},[_vm._v("")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c538b7ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/playing.vue
// module id = 1329
// module chunks = 382